import script from "./SwitchLanguage.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchLanguage.vue?vue&type=script&setup=true&lang=js"

import "./SwitchLanguage.vue?vue&type=style&index=0&id=cd3b36e6&scoped=true&lang=scss"

import exportComponent from "/home/node/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd3b36e6"]])

export default __exports__